export enum AnnotationType {
  FREE_TEXT = 'Free Text',
  STRIKEOUT = 'Strikeout',
  NOTE = 'Note',
}
